import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
import {useMaterialUIController} from "context";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {GET} from "APIclient";
import {POST} from "APIclient";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";

function Leaving(noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  // const fetchUrl = `admin/employee/get-roster/${usersState}`;
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [details, setDetails] = useState([]);
  let [data, setData] = useState([]);
  const [hrManager, setHrManager] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({
    leavingDate: dayjs(null),
    issuedBy: "",
    reasonForLeaving: "",
    comment: ""
  });

  const [errors, setErrors] = useState({
    leavingDate: "",
    issuedBy: "",
    reasonForLeaving: ""
  });

  const validateField = (name, value) => {
    switch (name) {
      case "leavingDate":
        if (!value) {
          return "Exit date is required";
        }
        if (!dayjs(value).isValid()) {
          return "Please select a valid date";
        }
        return "";
      case "issuedBy":
        return value ? "" : "Please select an issued by";
      case "reasonForLeaving":
        return value ? "" : "Please select a reason for exit";
      default:
        return "";
    }
  };

  React.useEffect(() => {
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [viewUrl]);

  const handleClose = () => {
    setOpen(false);
  };
  const columns = [
    {field: "id", headerName: "ID", width: 90},
    {
      field: "startDate",
      headerName: "Start Date",
      width: 150
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 150
    },
    {
      field: "reportingTo",
      headerName: "reportingTo",
      //   sortable: false,
      width: 160
      //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    {
      field: "Issued On",
      headerName: "issuedOn",
      // type: 'number',
      width: 160
    }
  ];

  // const rows = [
  //     { id: 1, startDate: '01/02/2023', endDate: '01/02/2024', reportingTo: 'Kiran Gurav', issuedOn: '' },
  //     { id: 2, startDate: '01/02/2022', endDate: '01/02/2023', reportingTo: 'Umesh Bihani', issuedOn: '' }
  // ];
  const handleCloseSnackbar = () => setSnackbar(null);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, value)
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;
    const formattedDate = validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null;

    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));

    setErrors(prev => ({
      ...prev,
      [field]: validateField(field, formattedDate)
    }));
  };

  const validateForm = () => {
    const newErrors = {
      leavingDate: validateField("leavingDate", formData.leavingDate),
      issuedBy: validateField("issuedBy", formData.issuedBy),
      reasonForLeaving: validateField("reasonForLeaving", formData.reasonForLeaving)
    };

    setErrors(newErrors);
    return Object.values(newErrors).every(error => error === "");
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    const dt = {
      empId: usersState,
      issuedBy: parseInt(formData.issuedBy),
      leavingDate: formData.leavingDate,
      reasonForLeaving: formData.reasonForLeaving
      // comment:"No additional comments"
    };

    const url = `admin/employee-exits`;

    try {
      const response = await POST(url, dt);
      if (response?.data?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage("Permissions updated successfully");
        setOpen(true);
        // Optionally navigate to another page after successful update
        // navigate('/some/other/page');
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update permissions");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      setSnakColor("error");
      setSnakMessage("Error updating permissions");
      setOpen(true);
    }
  };

  React.useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        const data = response?.data?.data;
        setHrManager(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHrManager();
  }, []);

  useEffect(() => {
    const isValid =
      formData.leavingDate &&
      dayjs(formData.leavingDate).isValid() &&
      formData.issuedBy &&
      formData.reasonForLeaving &&
      !errors.leavingDate &&
      !errors.issuedBy &&
      !errors.reasonForLeaving;

    setIsFormValid(isValid);
  }, [formData, errors]);

  const formattedDesignation = formatDesignation(details?.designation ?? "-");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={1}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  paddingBottom: "20px",
                  fontFamily: properties.fontFamily
                }}
              >
                Employee Exit
              </Typography>

              {/* <MDBox pt={1} pb={0} px={2}> */}
              <MDBox pt={0} px={2} mb={0}></MDBox>
              <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={2}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Employee Details
                  </MDTypography>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Joining Date:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {formattedDesignation}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        First Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.firstName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Middle Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.middleName : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Last Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.lastName : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Personal Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.emailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Official Email ID:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.officialEmailAddress : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Mobile:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.mobileNo : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              {/* </MDBox> */}
              {/* <DataGrid rows={rows} columns={columns} pagination={false} hideFooter={rows.length <= 20} hideFooterPagination={true} /> */}
              <MDBox pt={2} mb={0} pb={2} px={1}>
                {/* <InputLabel sx={{ fontWeight: 'bold', paddingBottom: '20px' }}>Reporting Details</InputLabel> */}
                <Typography
                  variant="h6"
                  fontWeight="medium"
                  pb={1}
                  sx={{fontFamily: properties.fontFamily}}
                >
                  Exit Details
                </Typography>
                <MDBox pt={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        sx={{m: 1, width: "30ch", paddingBottom: "20"}}
                        size="small"
                        label={
                          <span>
                            Exit Date <span style={{color: properties.colors.Red}}>*</span>
                          </span>
                        }
                        name="leavingDate"
                        value={formData ? dayjs(formData.leavingDate) : null}
                        onChange={date => handleDateChange(date, "leavingDate")}
                        slotProps={{
                          textField: {
                            error: !!errors.leavingDate,
                            helperText: errors.leavingDate
                          }
                        }}
                        // disabled={formData?.probationApplicable == '0'}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </MDBox>
                <MDBox pt={2}>
                  <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                    <InputLabel id="issuedBy">
                      Issued By <span style={{color: properties.colors.Red}}>*</span>
                    </InputLabel>
                    <Select
                      pb={4}
                      labelId="issuedBy"
                      id="issuedBy"
                      value={formData?.issuedBy}
                      name="issuedBy"
                      onChange={e => handleChange(e)}
                      label="issued By"
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      {hrManager?.map(manager => (
                        <MenuItem key={manager.empId} value={manager.empId}>
                          {`${manager.firstName} ${manager.lastName}`}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.issuedBy && (
                      <span style={{color: "red", fontSize: "0.75rem"}}>{errors.issuedBy}</span>
                    )}
                  </FormControl>
                </MDBox>
                <MDBox pt={2}>
                  <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                    <InputLabel id="reasonForLeaving">
                      Reason For Exit <span style={{color: properties.colors.Red}}>*</span>
                    </InputLabel>
                    <Select
                      pb={4}
                      labelId="reasonForLeaving"
                      id="reasonForLeaving"
                      value={formData?.reasonForLeaving}
                      name="reasonForLeaving"
                      onChange={e => handleChange(e)}
                      label="Select"
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      <MenuItem value="Absconding">Absconding</MenuItem>
                      <MenuItem value="Terminate">Terminate</MenuItem>
                      <MenuItem value="Resignation">Resignation</MenuItem>
                    </Select>
                    {errors.reasonForLeaving && (
                      <span style={{color: "red", fontSize: "0.75rem"}}>
                        {errors.reasonForLeaving}
                      </span>
                    )}
                  </FormControl>
                </MDBox>
              </MDBox>

              <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                <MDBox sx={{display: "flex", gap: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "20ch"}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{
                      width: "20ch",
                      ml: 2,
                      mr: 1,
                      background: properties.colors.bgcolorbluethem
                    }}
                    onClick={() => handleSubmit()}
                    disabled={!isFormValid}
                  >
                    Save
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                onClose={handleClose}
              >
                <Alert
                  autoHideDuration={1200}
                  onClose={handleClose}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%", color: "#fff"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default Leaving;
